import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IChuDeReducer } from "../../reducer-model/category/IChuDeReducer";
import { IChuDeActionTypes } from "../../action-types/category/IChuDeActions";
import { ISMT_ChuDe } from "../../../model/respone/category/ISMT_ChuDe";

const iniState: IChuDeReducer = {
  status: eReducerStatusBase.is_not_initialization,
  chuDes: [],
  isShowEditModal: false,
  idSelections: [],
  idNhomCauHoi: 0,
  chuDeEditing: {
    name: "",
    id: 0,
    parent_id: 0,
    id_nhomcauhoi: 0,
    note: "",
  } as ISMT_ChuDe,
};

export const chuDeReducer = (
  state: IChuDeReducer = iniState,
  action: IChuDeActionTypes
): IChuDeReducer => {
  switch (action.type) {
    case "CHU_DE_LOAD_START":
      return {
        ...state,
        idNhomCauHoi: action.payload,
        chuDes: [],
        status: eReducerStatusBase.is_loading,
      };
    case "CHU_DE_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuDes: action.payload,
      };
    case "CHU_DE_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHU_DE_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CHU_DE_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "CHU_DE_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHU_DE_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CHU_DE_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CHU_DE_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHU_DE_SHOW_EDIT_MODAL":
      return {
        ...state,
        chuDeEditing: action.payload,
        isShowEditModal: true,
      };
    case "CHU_DE_CLOSE_EDIT_MODAL":
      return {
        ...state,
        chuDeEditing: undefined,
        isShowEditModal: false,
      };
    case "CHU_DE_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "CHU_DE_IMPORT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CHU_DE_IMPORT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowImportModal: false,
      };
    case "CHU_DE_IMPORT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "CHU_DE_IMPORT_OPEN_MODAL":
      return {
        ...state,
        isShowImportModal: true,
      };
    case "CHU_DE_IMPORT_CLOSE_MODAL":
      return {
        ...state,
        isShowImportModal: false,
      };
    default:
      return state;
  }
};
